export const LIVE_CHAT_ICON_ID = 'live-chat-icon-id';
export const CHAT_DIALOG_HEADER_CONTENT_HEIGHT = 36;
export const DASHBOARD_LOCATION_NAME = 'Dashboard';
